import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { listTransition } from '@app/core/animations/list-animations';
import { Media } from '@app/shared';
import { SearchType } from '@app/shared/models/media';


// import { State } from './asset-search.component';
export enum State {
  LIST = "list",
  DETAIL = "detail",
}

@Component({
  selector: 'app-asset-search',
  templateUrl: './asset-search.component.html',
  styleUrls: ['./asset-search.component.scss'],
  animations: [ listTransition ]
})


export class AssetSearchComponent implements OnInit {

  @Output() onSearch = new EventEmitter<any>();
  @Output() onCloseClick = new EventEmitter<any>();
  @Input()
  public set assets(val:any[]){
    console.log(val);
    this._assets = val;
  }
  public get assets():any[]{
    return this._assets;
  }
  public searchType = SearchType;
  state = State;
  view_state = State.LIST;
  asset:Media;

  assetSearchType:string = SearchType.DECORATION;

  searchStr:string = "";
  private _assets:any[];

  constructor() { }

  ngOnInit() {
    if(this.searchStr === '')
      this.assets = [];
  }
 

  search():void{

    let oa = {product:null,keyword:this.searchStr,includeAssets:true,type:this.assetSearchType};

    if(this.searchStr.length)
      this.onSearch.emit(oa);
    else
      this.assets = [];
  }

  back():void{
    this.view_state = State.LIST;
  }
  closeClick():void{
    this.onCloseClick.emit();
  }

  onMediaClick(media:Media):void{
    // this.view_state = State.DETAIL;
    // this.asset = media;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/offer-editor/asset-search/asset-search.component.ts